import { useId, type ReactNode } from 'react';
import { SoonBadge } from './Badge';
import { cx } from './cx';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  disabled?: boolean;
  /** Affiche la pastille « Bientôt » et désactive l'interrupteur. */
  soon?: boolean;
  className?: string;
}

/** Ligne avec libellé et interrupteur (fond gris clair, arrondi 14). */
export function Switch({ checked, onChange, label, disabled = false, soon = false, className }: SwitchProps) {
  const id = useId();
  const off = disabled || soon;
  return (
    <div
      className={cx(
        'flex items-center gap-3 rounded-[14px] bg-surface-light px-3.5 py-3',
        off && 'cursor-not-allowed opacity-60',
        className,
      )}
    >
      <label htmlFor={id} className={cx('flex-1 text-[13px] leading-snug text-body', !off && 'cursor-pointer')}>
        {label}
        {soon && <SoonBadge />}
      </label>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={off}
        onClick={() => onChange(!checked)}
        className={cx(
          'relative h-[22px] w-[38px] shrink-0 rounded-[11px] transition-colors duration-200',
          'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary-100 disabled:cursor-not-allowed',
          checked ? 'bg-primary' : 'bg-line',
        )}
      >
        <span
          className={cx(
            'absolute left-[3px] top-[3px] h-4 w-4 rounded-full bg-white shadow-[0_1px_3px_rgba(15,23,42,.2)] transition-transform duration-200',
            checked && 'translate-x-4',
          )}
        />
      </button>
    </div>
  );
}
